import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { boat_details } from './boats.schema';
import { categories } from './categories.schema';
import { locations } from './locations.schema';

export const inventory = sqliteTable('inventories', {
  id: text('id').notNull().primaryKey(),
  laravel_id: integer('laravel_id'),
  user_id: integer('user_id'),
  name: text('name').notNull(),
  type: text('type'),
  category_id: integer('category_id'),
  category_uuid: text('category_uuid').references(() => categories.id),
  boat_detail_uuid: text('boat_detail_uuid').references(() => boat_details.id),
  boat_detail_id: integer('boat_detail_id'),
  organization_id: text('organization_id'),
  quantity: real('quantity'),
  unit: text('unit'),
  packing: text('packing'),
  notes: text('notes'),
  brand: text('brand'),
  model: text('model'),
  serial_number: text('serial_number'),
  part_number: text('part_number'),
  barcode: text('barcode'),
  vendor_page: text('vendor_page'),
  location_id: integer('location_id'),
  location_uuid: text('location_uuid').references(() => locations.id),
  supplier: text('supplier'),
  supplier_contact: text('supplier_contact'),
  supplier_url: text('supplier_url'),
  acquisition_date: text('acquisition_date'),
  expiration_date: text('expiration_date'),
  warranty_date: text('warranty_date'),
  usage_due_date: text('usage_due_date'),
  price: real('price'),
  unit_price: real('unit_price'),
  /** The currency the price is in. The backend converts from this column alone. */
  unit_price_currency_id: integer('unit_price_currency_id'),
  /** L8's currency for the old single `price`. No app writes it for inventory; conversion ignores it. */
  currency_id: integer('currency_id'),
  exchange_rate: real('exchange_rate'),
  total: real('total'),
  converted_total: real('converted_total'),
  minimum_quantity: real('minimum_quantity'),
  minimum_quantity_reminder: real('minimum_quantity_reminder'),
  minimum_quantity_unit: text('minimum_quantity_unit'),
  consumption: real('consumption'),
  usage_threshold: real('usage_threshold'),
  usage_log: text('usage_log'),
  current_usage_value: real('current_usage_value'),
  usage_recurrence: real('usage_recurrence'),
  voltage: real('voltage'),
  width: real('width'),
  height: real('height'),
  depth: real('depth'),
  weight: real('weight'),
  maintenance_needed: integer('maintenance_needed'),
  has_expiration_reminder: integer('has_expiration_reminder'),
  has_warranty_reminder: integer('has_warranty_reminder'),
  has_minimum_quantity_reminder: integer('has_minimum_quantity_reminder'),
  has_usage_reminder: integer('has_usage_reminder'),
  has_threshold_reminder: integer('has_threshold_reminder'),
  has_due_date_reminder: integer('has_due_date_reminder'),
  threshold_reminder_value: real('threshold_reminder_value'),
  threshold_recurrence_reminder: real('threshold_recurrence_reminder'),
  expiration_time_unit: integer('expiration_time_unit'),
  expiration_time_unit_type: text('expiration_time_unit_type'),
  warranty_time_unit: integer('warranty_time_unit'),
  warranty_time_unit_type: text('warranty_time_unit_type'),
  usage_time_unit: integer('usage_time_unit'),
  usage_time_unit_type: text('usage_time_unit_type'),
  usage_recurrence_time_unit: integer('usage_recurrence_time_unit'),
  usage_recurrence_time_unit_type: text('usage_recurrence_time_unit_type'),
  due_date_time_unit: integer('due_date_time_unit'),
  due_date_time_unit_type: text('due_date_time_unit_type'),
  usage_is_custom: integer('usage_is_custom'),
  expiration_is_custom: integer('expiration_is_custom'),
  warranty_is_custom: integer('warranty_is_custom'),
  is_recurring: integer('is_recurring'),
  recurrence_type: text('recurrence_type'),
  is_enabled: integer('is_enabled'),
  linked_inventories_ids: text('linked_inventories_ids'),
  linked_inventories_uuids: text('linked_inventories_uuids'),
  task_id: integer('task_id'),
  /** `general`, `engine` or `generator` on an asset — see `inventoryAssetTypes`. Null on a consumable. */
  asset_kind: text('asset_kind'),
  /** Engines and generators only; the backend clears all five on any other kind. */
  power: real('power'),
  power_unit: text('power_unit'),
  fuel: text('fuel'),
  /** Engines only. Named for the column: `type` is the stock-behaviour axis. */
  engine_type: text('engine_type'),
  drive: text('drive'),
  /** The item's cover photo, as the file's uuid. No `image_id`: the backend takes the uuid alone. */
  image_uuid: text('image_uuid'),
  imported_at: text('imported_at'),
  deleted_at: text('deleted_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});

export const inventoriables = sqliteTable('inventoriables', {
  id: text('id').notNull().primaryKey(),
  inventory_id: integer('inventory_id'),
  inventory_uuid: text('inventory_uuid'),
  inventoriable_id: integer('inventoriable_id'),
  inventoriable_type: text('inventoriable_type'),
  inventoriable_uuid: text('inventoriable_uuid'),
  usage_value: integer('usage_value'),
  usage_log_name: text('usage_log_name'),
  quantity_action: text('quantity_action'),
  quantity: integer('quantity'),
  user_id: integer('user_id'),
  organization_id: text('organization_id'),
});
